const divTableActions = {
  noResults: 'Nenhum resultado encontrado',
  noAccountable: 'Sem Responsável'
};

export default divTableActions;
